<template>
  <label :class="{'required': field.required}" :for="`select-project-input-${parent}-${field.name}`">
    {{ normalizedFieldLabel }}
    <SVGIcon
      v-if="field.description"
      v-tooltip="field.description"
      :width="'20px'"
      :height="'20px'"
      :iconName="'info'"
      class="help-logo"
    />
  </label>
  <select
    :id="`select-project-input-${parent}-${field.name}`"
    :value="modelValue"
    class="select"
    @input="$emit('update:modelValue', $event.target.value)"
  >
    <option
      v-for="(project, i) in projects"
      :key="`dropdown-${parent}-${field.name}-${i}-${project.name}`"
      :value="project.id"
    >
      {{ project.name }}
    </option>
  </select>

  <!-- <template v-if="getSelectChildren(field)">
          <SchemaGroup
            v-for="childKey in Object.keys(parameters[field.name])"
            :id="`parent-${field.name}`"
            :key="childKey"
            v-model:params="parameters[field.name][childKey]"
            :fields="getSelectChildren(field)"
            :parent="field.name"
          />
        </template> -->
</template>

<script setup>
import {
  ref, computed, toRefs, onMounted,
} from 'vue';
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import { useStore } from 'vuex';

const props = defineProps({
  field: {
    type: Object,
    default: () => {},
  },
  modelValue: {
    type: Object,
    default: null,
  },
});

const {
  parent,
  field,
} = toRefs(props);

const normalizedFieldLabel = computed(() => {
  const rawLabel = field.value?.label || field.value?.Label || field.value?.name || 'Project';
  return String(rawLabel).replace(/\s*\*+\s*$/, '');
});

const emit = defineEmits(['update:modelValue']);

async function getProjects() {
 
    const dataConnect = new DatastoreConnect();
    const proj = await dataConnect.getProjectList({})
      .then((resp) => {
        if (resp.error) {
          throw resp.error;
        }
        return resp.result;
      })
      .catch((error) => {
        console.error(error);
      });

    console.log(proj);
    return proj;
}

const store = useStore();
const currentProject = computed(() => store.state.projects.currentProject);
const projects = ref(null);

onMounted(async () => {
  projects.value = await getProjects();
  if (currentProject) {
    emit('update:modelValue', currentProject.value.id);
  } else  if (projects.value.length > 0) {
    emit('update:modelValue', projects.value[0].id);
  }
});
</script>
